/**
 * @file useTemplateAppliesTo.ts
 * @description Сколько товаров получат шаблон страницы товара (phase19.16
 * Р2а; uiux-design-r2a §7 «Изменён шаблон страницы товара (N товаров)»;
 * контракт §19.3 `appliesTo`). Окно публикации спрашивает сервер при
 * открытии, если шаблон изменён, — число верно и вне экрана шаблона.
 * Не получилось (нет права, сбой) — `null`: окно пишет «все товары на сайте».
 */

import { useEffect, useState } from "react";

import { siteTemplates } from "../../lib/api-site-templates";

export function useTemplateAppliesTo(enabled: boolean): number | null {
  const [appliesTo, setAppliesTo] = useState<number | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    siteTemplates
      .product()
      .then((res) => alive && setAppliesTo(res.appliesTo))
      .catch(() => alive && setAppliesTo(null));
    return () => {
      alive = false;
    };
  }, [enabled]);
  return enabled ? appliesTo : null;
}
